/*
 0: version strings are equal
 1: version a is greater than b
-1: version a is smaller than b
*/
export const compareVersion = (a, b) => {
  return a.localeCompare(b || '0.0.0', undefined, { numeric: true, sensitive: 'base' });
};
